import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { handleLogin, handleLogout } from '../../redux/actions/common';
import LeftDrawer from './LeftDrawer';
import TopBar from './TopBar';

const RootNav = ({ login, logout }) => {
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) { login() }
  }, [login]);

  if (location.pathname !== '/login' && location.pathname !== '/privacy-policy' && location.pathname !== '/mllg-privacy-policy') {
    return (
      <nav>
        <TopBar logout={logout} />
        <LeftDrawer logout={logout} />
      </nav>
    );
  }
  return null;
};

const mapActions = {
  login: handleLogin,
  logout: handleLogout,
};

export default connect(null, mapActions)(RootNav);
